import React, { useMemo } from "react";
import { Switch, Route } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { Pager } from "rhombus-react";

import { QA } from "reducers/QA";

import Grid from "./qa/Grid";

import ApprovalModal from "widgets/modals/qa/ApprovalModal";
import ReportsModal from "widgets/modals/qa/ReportsModal";

import FilterTagList from "widgets/toolbars/FilterTagList";

import { useCollectionFiltering } from "utils/DataGrid";
import { QA_ROW_COUNT_OPTIONS } from "utils/constants";
import { useTooltipRebuild } from 'hooks/useTooltipRebuild';
import useCancelToken from "hooks/useCancelToken";

import Toolbar from "./qa/Toolbar";

import "./QAPanel.css";

export default function QAPanel({ libraryID, creativeId }){
	const dispatch = useDispatch();
	let { qa, currentSelection } = useSelector((state) => {
		return {
			qa:state.qa,
			currentSelection:state.selected.qa || [],
		};
	});
	const { getNewToken } = useCancelToken(true);

	let qaList = useMemo(() => {
		return qa.items.map((v) => {
			return {
				...v,
				isSelected:currentSelection.includes(v.id),
			};
		});
	}, [qa.items, currentSelection]);

	const {
		filterInfo: { page, rpp, searchTerm, sort },
		columnFilters,
	} = useCollectionFiltering(
		qa,
		QA.setAdvancedFilter,
		() => {
			dispatch(QA.loadQA(getNewToken()));
		 }
	);

	useTooltipRebuild([]);

	let $toolbar = (
		<Toolbar key = "toolbar"
			searchTerm = { searchTerm }
			handleSearch = { (newSearchTerm) => {
				dispatch(QA.setSearchTerm(newSearchTerm));
			}}
		/>
	);

	let $filterTagList = (
		<FilterTagList
			key="filter-tags"
			Reducer = {QA}
			filters = {columnFilters}
		/>
	);

	const pagerProps = {
		showItemCount: true,
		initialPage: page,
		forcePage: page,
		pageSize: rpp,
		pageCount: qa.totalPages,
		maxItems: qa.totalItems,
		showItemWord: "",
		rowCountItems: QA_ROW_COUNT_OPTIONS,

		disabled: !qa.isLoaded,

		onPageChange: newPage => dispatch(QA.setPage(newPage)),
		onRowCountChange: newRPP => dispatch(QA.setRPP(newRPP)),
	};

	return (
		<section className="qa-panel">
			<Switch>
				<Route path={"/qa-panel/reports/"} render={() => {
					return <ReportsModal />;
				}} />
				<Route path={"/qa-panel/approvals/:libraryId/"} render={() => {
					return <ApprovalModal />;
				}} />
			</Switch>
			{$toolbar}
			{$filterTagList}
			<Grid items={qaList} sort={sort} isLoading={!qa.isLoaded} />
			<Pager key="pager" {...pagerProps} />
		</section>
	);
}
